function u(e, r = "") {
  return Object.keys(e).filter((t) => t.startsWith("data-")).reduce((t, a) => (t[a] = e[a] + r, t), {});
}
function i(e) {
  return Object.keys(e).filter((r) => !r.startsWith("data-")).reduce((r, t) => (r[t] = e[t], r), {});
}
export {
  i as getAllButDataAttributes,
  u as getDataAttributes
};
//# sourceMappingURL=attribute-util.js.map
